import { useTranslation } from 'react-i18next';
import { supportedLanguages } from '../i18n';
import { Select } from './Select';
import { cln } from '../lib/utils';

type Props = {
  onChange: (event: any) => void;
  value?: string;
  label?: string;
  error?: string;
  required?: boolean;
};

export default function LanguageSelector(props: Props) {
  const { t } = useTranslation();
  const { onChange, value, label, error, required } = props;
  const id = crypto.randomUUID();

  return (
    <span>
      {label && (
        <label htmlFor={id} className={cln(error && '!text-danger-500', 'text-label capitalize')}>
          {t(label)}
          {required && <span className="text-[red]">*</span>}
        </label>
      )}
      <Select className="bg-transparent" value={value} onChange={onChange}>
        {supportedLanguages.map((language) => (
          <option key={language} value={language}>
            {t(`common.languages.${language}`)}
          </option>
        ))}
      </Select>
    </span>
  );
}
